import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { PROFESSIONAL_POSITION_CANDIDATES } from '../../../../../../define/consts/profile';
import { RFP_INVOLVEMENTS, RFP_ROLES, } from '../../../../../../define/consts/rfp';
import { propArrayShape } from '../../../../../../helpers/custom-prop-types';
import MemberRow from './MemberRow';
const MemberRows = (props) => {
    const { offerMembers } = props;
    const members = useMemo(() => offerMembers.map((offerMember) => {
        const involvement = RFP_INVOLVEMENTS.find((v) => v.value === offerMember.involvement);
        const position = PROFESSIONAL_POSITION_CANDIDATES.find((v) => v.value === offerMember.position) || {};
        const positionName = position.other
            ? offerMember.position_other
            : position.label;
        const role = RFP_ROLES.find((v) => v.value === offerMember.role);
        return Object.assign(Object.assign({}, offerMember), { involvementName: (involvement || {}).label || '', positionName: positionName || '', roleName: (role || {}).label || '' });
    }), [offerMembers]);
    return (_jsxs("div", Object.assign({ className: 'rfp-member-items' }, { children: [_jsx("h5", Object.assign({ className: 'title_value' }, { children: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30E1\u30F3\u30D0\u30FC" })), _jsx("ul", Object.assign({ className: 'offer_member_list' }, { children: members.map((offerMember) => (_jsx(MemberRow, { value: offerMember }, offerMember.id))) }))] })));
};
MemberRows.propTypes = {
    offerMembers: propArrayShape().isRequired,
};
export default MemberRows;
